import { orderStatus, orderRefundStatus, refundmentType, refundReturn, onlyRefundReason, sendGoodsStutes, sampleType,
  invoiceTypes, invoiceStates, refundModes, refundModesIntegral, channelOptions , channelFiltterOptions } from 'json/goods-order-options'
import { goodsBelongLabels } from 'json/mall-options'
import { targetFroms } from 'json/link-manage'
export let paidOrderLabels = [
  {
    label: '订单时间',
    type: 'time-slot',
    startName: 'orderCreateTimeStart', // 返回数据时，开始时间的字段名
    endName: 'orderCreateTimeEnd', // 返回数据时，结束时间的字段名
    value: 'createdtime'
  },
  //   {
  //     label: '用户名',
  //     type: 'select',
  //     value: 'mallUserNickName',
  //     options: [],
  //     clearable: true
  //   },
  //   {
  //     label: '商品名称',
  //     type: 'select',
  //     value: 'goodsName',
  //     options: [],
  //     clearable: true
  //   },
  //   {
  //     label: '订单状态',
  //     type: 'select',
  //     value: 'orderStatus',
  //     options: orderStatus,
  //     clearable: true
  //   },
  {
    label: '商品归属',
    type: 'select',
    value: 'goodsBelong',
    clearable: true,
    options: goodsBelongLabels
  },
  {
    label: '运营活动',
    type: 'select',
    value: 'promotionEventObjectId',
    clearable: true,
    options: [],
    props: {
      label: 'promotionEventName',
      value: 'promotionEventObjectId'
    }
  },
  {
    label: '商品分组',
    type: 'select',
    value: 'goodsGroupName',
    clearable: true,
    props: {
      label: 'name',
      value: 'name'
    },
    options: []
  },
  {
    label: '商品类型',
    value: 'goodsType',
    type: 'select',
    clearable: true,
    props: {
      label: 'name',
      value: 'value'
    },
    options: []
  },
  {
    label: '订单类型',
    value: 'type',
    type: 'select',
    clearable: true,
    options: [
      {
        label: '商城订单',
        value: 'GOODS'
      },
      {
        label: 'CPS订单',
        value: 'CONTRACT'
      }
    ]
  },
  {
    label: '第三方供应商',
    type: 'select',
    props: {
      label: 'name',
      value: 'name'
    },
    options: [],
    value: 'organizationName',
    clearable: true
  },
  {
    label: '分享成单',
    value: 'goodsSharingOrder',
    type: 'select',
    options: [
      {
        label: '是',
        value: 'true'
      },
      {
        label: '否',
        value: 'faslse'
      }
    ]
  },
  {
    label: '分/子公司',
    value: 'orderOrganizationId',
    type: 'select',
    options: [],
    filterable: true,
    clearable: true,
    props: {
      label: 'fullName',
      value: 'id'
    }
  }
]

export let orderOfIdentity =
  [
    {
      label: '储户',
      value: 'DEPOSITOR'
    },
    {
      label: '业务员',
      value: 'SALESMEN'
    },
    {
      label: '医护人员',
      value: 'DOCTOR'
    }
  ]
export let allOrderLabels = [
  {
    label: '订单状态',
    type: 'select',
    value: 'orderStatus',
    options: [
      {
        label: '待支付',
        value: 'UNPAID'
      },
      {
        label: '已支付订金',
        value: 'DEPOSIT_PAID'
      },
      {
        label: '已支付尾款',
        value: 'BALANCE_PAID'
      },
      {
        label: '已支付全款',
        value: 'FULL_PAID'
      },
      {
        label: '已支付',
        value: 'PAID'
      },
      {
        label: '已完成',
        value: 'COMPLETED'
      },
      {
        label: '已关闭',
        value: 'CLOSED'
      }
    ],
    clearable: true
  },
  ...paidOrderLabels,
  {
    label: '订单来源',
    value: 'businessSource',
    type: 'select',
    options: targetFroms
  },
  {
    label: '分享人身份',
    value: 'sharerIdentity',
    type: 'select',
    options: orderOfIdentity
  },
  {
    label: '购买人身份',
    value: 'placeUserIdentity',
    type: 'select',
    options: orderOfIdentity
  },
  {
    label: '支付方式',
    value: 'payChannel',
    type: 'select',
    options: channelFiltterOptions,
    clearable: true
  }
]
export let orderSteps = [
  {
    title: '已下单',
    description: ''
  },
  {
    title: '已付款',
    description: ''
  },
  {
    title: '已发货',
    description: ''
  }
]
export let refundOrderLabels = [
  {
    label: '订单号',
    type: 'input',
    clearable: true,
    value: 'orderNumber', // 需返回数据的字段名
    options: []
  },
  {
    label: '申请退款时间',
    type: 'time-slot',
    startName: 'applyStartTime', // 返回数据时，开始时间的字段名
    endName: 'applyEndTime', // 返回数据时，结束时间的字段名
    value: 'createdtime'
  },
  {
    label: '退款方式',
    type: 'select',
    clearable: true,
    value: 'refundmentType',
    options: refundmentType
  },
  {
    label: '退款编号',
    type: 'input',
    clearable: true,
    value: 'refundOrderNumber'
  },
  {
    label: '退款状态',
    type: 'select',
    clearable: true,
    value: 'orderRefundStatus',
    options: orderRefundStatus
  }
]
export let receiptTableLabels = [
//   {
//     label: '发票申请流水号',
//     value: 'request.requestId'
//   },
//   {
//     label: '发票号',
//     value: 'request.number'
//   },
//   {
//     label: '发票抬头',
//     value: 'information.title'
//   },
  {
    label: '金额（元）',
    value: 'invoiceAmount'
  },
  {
    label: '发票内容',
    value: 'information.content'
  },
  {
    label: '开票时间',
    value: 'time'
  },
  {
    label: '发票形式',
    value: 'invoiceForm'
  },
  {
    label: '发票类型',
    value: 'invoiceType'
  },
  {
    label: '开票状态',
    value: 'invoiceState'
  }
]
// 退款列表状态筛选
export let refundOrderStatusTab = [
  {
    label: '全部退款订单',
    value: 'all'
  },
  {
    label: '待退款',
    value: 'SUBMITTED'
  },
  {
    label: '退款完成',
    value: 'REFUND_COMPLETED'
  }
]
export let refundTableLabel = [
  {
    label: '退款编号',
    value: 'refundmentDetails.refundOrderNumber'
  },
  {
    label: '订单编号',
    value: 'orderNumber'
  },
  {
    label: '商品名称',
    value: 'goodsName'
  },
  {
    label: '退款金额',
    value: 'refund_amount'
  },
  {
    label: '退款方式',
    value: 'refundmentType'
  },
  {
    label: '退款申请时间',
    value: 'applyTime'
  },
  {
    label: '退款状态',
    value: 'orderRefundStatus'
  }
]
export let applyRefundReason = [
  {
    label: '',
    value: 'QUALITY_AND_SPECIFICATION'
  },
  {
    label: '',
    value: 'DELIVERY_ERROR'
  },
  {
    label: '',
    value: 'GOODS_DAMAGED'
  },
  {
    label: '',
    value: 'EXPRESS_NOT_ARRIVE'
  },
  {
    label: '',
    value: 'UNSHIPPED'
  }
]
export let onlyRefund = onlyRefundReason
export let refundReturns = refundReturn
export let sendGoods = sendGoodsStutes
// export let refundChannel = refundChannels
export let refundChannel = [
  {
    label: '原路返回',
    value: 'RETURN_PLACED_WAY'
  }
]
// 样本类型枚举
export let sampleTypes = sampleType
// 待重采订单列表，顶部筛选
export let sampleRecollectFilterFactor = [
  {
    label: '订单时间',
    type: 'time-slot',
    value: 'orderTime',
    startName: 'orderDateStart', // 返回数据时，开始时间的字段名
    endName: 'orderDateEnd' // 返回数据时，结束时间的字段名
  }
]
export let sampleRecollectTableLabel = [
  {
    label: '订单号',
    value: 'mallOrderNumber'
  },
  {
    label: '订单内容',
    value: 'orderContent'
  },
  {
    label: '订单创建时间',
    value: 'order_createdDate'
  },
  {
    label: '样本条码号',
    value: 'sampleId'
  },
  {
    label: '受检人',
    value: 'patientName'
  },
  {
    label: '产品名称',
    value: 'productName'
  },
  {
    label: '检测状态',
    value: 'order_status'
  },
  {
    label: '订单金额（元）',
    value: 'order_amount'
  },
  {
    label: '重采价格（元）',
    value: 'resample_amount'
  }
]
export let invoiceType = invoiceTypes
export let invoiceState = invoiceStates
// 重采订单是否需要开发票
export let needInvoice = [
  {
    label: '是',
    value: 'true'
  },
  {
    label: '否',
    value: 'false'
  }
]
export let invoiceLabels = [
  {
    label: '否',
    value: false
  },
  {
    label: '是',
    value: true
  }
]
// 带重采订单顶部tab
export let sampleRecollectTabs = [
  {
    value: 'GENE_DETECTION',
    label: '基因检测订单'
  },
  {
    value: 'ADULT_STORAGE',
    label: '成人存储订单'
  }
]
// 退款形式(手动退款还是自动退款)
export let refundMode = refundModes
export let refundModeIntegral = refundModesIntegral
